<div *ngIf="show">
  <div class="loader-overlay">
    <div *ngIf="show"
         class="loader"></div>
  </div>
</div>
<div *ngIf="block" class="blocker-overlay"></div>
